import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "reservarMesa",
  "use": "reservarMesa-usage",
  "viewBox": "0 0 24 13",
  "content": "<symbol viewBox=\"0 0 24 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"reservarMesa\"><title>dinner</title><path d=\"M22.91 11.138a10.87 10.87 0 0 0-3.165-6.775 10.872 10.872 0 0 0-7.042-3.185V.018h-1.406v1.16a10.872 10.872 0 0 0-7.042 3.185 10.87 10.87 0 0 0-3.165 6.775H0v1.406h24v-1.406h-1.09zm-20.408 0C2.99 6.328 7.063 2.56 12 2.56c4.937 0 9.01 3.767 9.498 8.577H2.502z\" /><path d=\"M7.379 5.501A8.047 8.047 0 0 0 4.468 9.23l1.313.502a6.646 6.646 0 0 1 2.405-3.078A6.614 6.614 0 0 1 12 5.453V4.045a8.013 8.013 0 0 0-4.621 1.455z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol